module.exports = __webpack_public_path__ + "static/1-d9b20bb4d507c12131e4c57e6eedfe70.png";